export const namespaced = true
const getDefaultState = () => {
    return {
        contractRegistration: [],
        selectedContractRegistration: null,
        count: 0,
    }
}
export const state = getDefaultState()

export const mutations = {

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    }
}

export const actions = {
    resetState({commit}) {
        commit('RESET_STATE')
    },
}


export const getters = {
}